export default __webpack_public_path__ + "static/media/Icon awesome-pencil-alt.08425a32.svg";